import moment from 'moment';
import React from 'react';
import { Button, Col, Row } from 'reactstrap';
import * as Yup from 'yup';
import { DATE_DISPLAY_FORMAT, LAYOUT_TYPE, REGEX, ADD_EXCEPTION_DATE_URL, WORKING_HOUR_MANAGEMENT_URL } from '../../App/AppSettings';
import Layout from '../../Layout';
import { ERROR } from '../../Localization';
import { navigateTo } from '../../Shared/Actions';
import { FIELD_SIZE } from '../../Shared/Constants';
import { Plaintext, DateInput, SelectList, SMARTForm, ToggleSwitchBoolean } from '../../Shared/Forms';
import { toastError, toastSuccess } from '../../Shared/Forms/Toaster.js';
import history from '../../Shared/History';
import PageFooter from '../../Shared/PageFooter';

const FORM_CONTEXT = "WorkingHourExcepConfig";

const FORM_VALIDATIONS = Yup.object().shape({
    WorkingHourCategory: Yup.string().required(ERROR.REQUIRED).min(0, ERROR.MIN_LENGTH_LIMIT).max(140, ERROR.MAX_LENGTH_LIMIT),
    WorkingHourDayofWeek: Yup.string(),
    WorkingHourExceptionDate: Yup.string().required(ERROR.REQUIRED).matches(REGEX.DATE, ERROR.DATE_INVALID),
    WorkingHourWorkStart: Yup.string(),
    WorkingHourWorkEnd: Yup.string(),
    WorkingHourBreakStart: Yup.string(),
    WorkingHourBreakEnd: Yup.string(),
});

const FORM_INITIAL_VALUES = {
    WorkingHourCategory: '',
    WorkingHourDayofWeek: '',
    WorkingHourExceptionDate: '',
    WorkingHourWorkStart: '',
    WorkingHourWorkEnd: '',
    WorkingHourBreakStart: '',
    WorkingHourBreakEnd: '',
    WorkingHourWorkingDay: true
};

function getDayFromDate(date) {
    var d = new Date(date).getDay();
    if (d===0) d=7;
    return (d.toString());
}

//Time validation Work End
function checkWorkEnd(start, end) {
    var mStart = moment(start, DATE_DISPLAY_FORMAT.TIME);
    var mEnd = moment(end, DATE_DISPLAY_FORMAT.TIME);
    if (mEnd.isBefore(mStart)) return ERROR.TIME_INVALID_WE;
}

//Time validation Break Start
function checkBreakStart(start, end) {
    var mStart = moment(start, DATE_DISPLAY_FORMAT.TIME);
    var mEnd = moment(end, DATE_DISPLAY_FORMAT.TIME);
    if (mEnd.isBefore(mStart)) return ERROR.TIME_INVALID_BS;
}

//Time validation Break start, Work end
function checkBSWE(start, end) {
    var mStart = moment(start, DATE_DISPLAY_FORMAT.TIME);
    var mEnd = moment(end, DATE_DISPLAY_FORMAT.TIME);
    if (mEnd.isBefore(mStart)) return ERROR.TIME_INVALID_BSWE;
}

//Time validation Break End
function checkBreakEnd(start, end) {
    var mStart = moment(start, DATE_DISPLAY_FORMAT.TIME);
    var mEnd = moment(end, DATE_DISPLAY_FORMAT.TIME);
    if (mEnd.isBefore(mStart)) return ERROR.TIME_INVALID_BE;
}

class WorkingHourCreateException extends React.Component {
    constructor(props) {
        super(props);
        
        if (history.location.state && history.location.state[FORM_CONTEXT]) {
            this.state = {
                category: history.location.state.Category,
                values: history.location.state[FORM_CONTEXT],
                dropDownArrayCategory: [],
            };

            history.replace({
                pathname: history.location.pathname,
                state: {}
            });
        }
        else {
            this.state = {
                category: history.location.state.Category,
                values: FORM_INITIAL_VALUES,
                dropDownArrayCategory: [],
            };
        }
    }

    submitCallback = ({ response }) => {
        if (response.success) {
            const { IsSuccess, RedirectURL, Message } = response.body;
            if (IsSuccess) {
                if (RedirectURL) {
                    navigateTo(RedirectURL, "");
                } else {
                    navigateTo(WORKING_HOUR_MANAGEMENT_URL, "");
                }
                toastSuccess("Exception Date has been added successfully.");
            }
            else {
                toastError(Message);
            }
        } else {
            toastError("Server could not be reached, please try again later")
        }
    }

    // Massage values before form submission
    massageValue = (values, submitPlainForm) =>{

        // Reset WorkStart, WorkEnd, BreakStart, Breakend if WorkingDay is set to false
        if (!values.WorkingHourWorkingDay) {
            values.WorkingHourWorkStart = "";
            values.WorkingHourWorkEnd = "";
            values.WorkingHourBreakStart = "";
            values.WorkingHourBreakEnd = "";
        }

        // Set Category
        values.WorkingHourCategory = this.state.category;

        submitPlainForm();
    }

    render() {
        return (
            <React.Fragment>
                <Layout type={LAYOUT_TYPE.FORM} title="New Exception Date">
                    <SMARTForm
                        formContext={FORM_CONTEXT}
                        formValues={this.state.values}
                        validationSchema={FORM_VALIDATIONS}
                        validateOnSubmit={true}
                        serverURL={ADD_EXCEPTION_DATE_URL}
                        isDummy={false}
                        submitCallback={this.submitCallback}
                        resetFormAfterSubmit={true}
                    >
                        {({ values, errors, onChangeField, submitPlainForm }) => (
                            <React.Fragment>
                                <Row className="body-content admin-content-wrapper">
                                    <Col>
                                        <Plaintext
                                            name="WorkingHourCategory"
                                            value={this.state.category}
                                            placeholder={"Category"}
                                            inputSize={FIELD_SIZE.LARGE}
                                            label={"Category"}
                                            required
                                        />
                                        <DateInput
                                            name="WorkingHourExceptionDate"
                                            value={values.WorkingHourExceptionDate}
                                            placeholder="Exception Date"
                                            onChangeField={onChangeField}
                                            time={false}
                                            date={true}
                                            min="1900-01-01 00:00"
                                            max="2100-12-31 00:00"
                                            format={DATE_DISPLAY_FORMAT.DATE}
                                            inputSize={FIELD_SIZE.SMALL}
                                            label="Exception Date"
                                            error={errors.WorkingHourExceptionDate}
                                            required
                                        />
                                        <SelectList
                                            name="WorkingHourDayofWeek"
                                            value={values.WorkingHourExceptionDate === "" ? values.WorkingHourDayofWeek.toString() : getDayFromDate(values.WorkingHourExceptionDate)}
                                            options={[
                                                { label: "Monday", value: "1" },
                                                { label: "Tuesday", value: "2" },
                                                { label: "Wednesday", value: "3" },
                                                { label: "Thursday", value: "4" },
                                                { label: "Friday", value: "5" },
                                                { label: "Saturday", value: "6" },
                                                { label: "Sunday", value: "7" }]
                                            }
                                            placeholder="Day of Week"
                                            onChangeField={onChangeField}
                                            isMulti={false}
                                            inputSize={FIELD_SIZE.SMALL}
                                            label="Day of Week"
                                            isDisabled={true}
                                        />
                                        <ToggleSwitchBoolean
                                            name="WorkingHourWorkingDay"
                                            value={values.WorkingHourWorkingDay}
                                            onChangeField={onChangeField}
                                            inputSize={FIELD_SIZE.SMALL}
                                            trueText="Work"
                                            falseText="No Work"
                                            defaultOn={true}
                                            label="Is Working Day"
                                        />
                                        <DateInput
                                            name="WorkingHourWorkStart"
                                            value={!values.WorkingHourWorkingDay ? "" : values.WorkingHourWorkStart}
                                            placeholder="Work Start"
                                            onChangeField={onChangeField}
                                            time={true}
                                            date={false}
                                            min="1900-01-01 00:00"
                                            max="2100-12-31 00:00"
                                            format={DATE_DISPLAY_FORMAT.TIME}
                                            inputSize={FIELD_SIZE.SMALL}
                                            label="Work Start"
                                            error={errors.WorkingHourWorkStart}
                                            disabled={!values.WorkingHourWorkingDay ? true : false}
                                        />
                                        <DateInput
                                            name="WorkingHourWorkEnd"
                                            value={!values.WorkingHourWorkingDay ? "" : values.WorkingHourWorkEnd}
                                            placeholder="Work End"
                                            onChangeField={onChangeField}
                                            time={true}
                                            date={false}
                                            min="1900-01-01 00:00"
                                            max="2100-12-31 00:00"
                                            format={DATE_DISPLAY_FORMAT.TIME}
                                            inputSize={FIELD_SIZE.SMALL}
                                            label="Work End"
                                            error={!values.WorkingHourWorkingDay ? "" : checkWorkEnd(values.WorkingHourWorkStart, values.WorkingHourWorkEnd)}
                                            disabled={!values.WorkingHourWorkingDay ? true : false}
                                        />
                                        <DateInput
                                            name="WorkingHourBreakStart"
                                            value={!values.WorkingHourWorkingDay ? "" : values.WorkingHourBreakStart}
                                            placeholder="Break Start"
                                            onChangeField={onChangeField}
                                            time={true}
                                            date={false}
                                            min="1900-01-01 00:00"
                                            max="2100-12-31 00:00"
                                            format={DATE_DISPLAY_FORMAT.TIME}
                                            inputSize={FIELD_SIZE.SMALL}
                                            label="Break Start"
                                            error={!values.WorkingHourWorkingDay ? "" : checkBreakStart(values.WorkingHourWorkStart, values.WorkingHourBreakStart) || checkBSWE(values.WorkingHourBreakStart, values.WorkingHourWorkEnd)}
                                            disabled={!values.WorkingHourWorkingDay ? true : false}
                                        />
                                        <DateInput
                                            name="WorkingHourBreakEnd"
                                            value={!values.WorkingHourWorkingDay ? "" : values.WorkingHourBreakEnd}
                                            placeholder="Break End"
                                            onChangeField={onChangeField}
                                            time={true}
                                            date={false}
                                            min="1900-01-01 00:00"
                                            max="2100-12-31 00:00"
                                            format={DATE_DISPLAY_FORMAT.TIME}
                                            inputSize={FIELD_SIZE.SMALL}
                                            label="Break End"
                                            error={!values.WorkingHourWorkingDay ? "" : checkBreakEnd(values.WorkingHourBreakStart, values.WorkingHourBreakEnd)}
                                            disabled={!values.WorkingHourWorkingDay ? true : false}
                                        />
                                    </Col>
                                </Row>
                                <PageFooter type={LAYOUT_TYPE.FORM}>
                                    <Button color="backward" size="sm" type="button" onClick={() => navigateTo(WORKING_HOUR_MANAGEMENT_URL)}>Back</Button>
                                    <Button color="forward" size="sm" type="button" onClick={() => this.massageValue(values, submitPlainForm)}>Submit</Button>
                                </PageFooter>
                            </React.Fragment>
                        )}
                    </SMARTForm>
                </Layout>
            </React.Fragment>
        );
    }
}

export default WorkingHourCreateException;

